export default function Teachers() {
  const teachers = [
    {
      name: "TS. Nguyễn Văn Minh",
      position: "Trưởng khoa Toán học",
      specialization: "Olympic Toán quốc tế",
      experience: "20 năm kinh nghiệm",
      achievements: "Cựu HCV IMO, Tiến sĩ Toán học ĐH Harvard",
      image:
        "https://readdy.ai/api/search-image?query=Professional%20Vietnamese%20mathematics%20professor%20in%20formal%20attire%2C%20middle-aged%20man%20with%20glasses%20and%20friendly%20smile%2C%20academic%20setting%20with%20mathematical%20formulas%20in%20background%2C%20professional%20headshot%20style%20with%20clean%20white%20background&width=400&height=400&seq=teacher-math-1&orientation=squarish",
    },
    {
      name: "ThS. Trần Thị Hoa",
      position: "Giảng viên Lập trình",
      specialization: "Olympic Tin học & AI",
      experience: "15 năm kinh nghiệm",
      achievements: "Cựu HCB IOI, Thạc sĩ Khoa học Máy tính MIT",
      image:
        "https://readdy.ai/api/search-image?query=Professional%20Vietnamese%20female%20computer%20science%20teacher%2C%20young%20woman%20with%20modern%20appearance%20and%20confident%20smile%2C%20technology%20classroom%20background%20with%20computers%20and%20coding%20displays%2C%20professional%20headshot%20with%20clean%20white%20background&width=400&height=400&seq=teacher-cs-1&orientation=squarish",
    },
    {
      name: "PGS.TS. Lê Đức Thành",
      position: "Phó Hiệu trưởng",
      specialization: "Hình học & Tổ hợp",
      experience: "25 năm kinh nghiệm",
      achievements: "Giáo sư trẻ nhất VN, tác giả 50+ công trình khoa học",
      image:
        "https://readdy.ai/api/search-image?query=Distinguished%20Vietnamese%20mathematics%20professor%2C%20senior%20academic%20with%20gray%20hair%20and%20wise%20expression%2C%20formal%20academic%20attire%2C%20university%20office%20setting%20with%20books%20and%20awards%2C%20professional%20portrait%20with%20clean%20white%20background&width=400&height=400&seq=teacher-math-2&orientation=squarish",
    },
    {
      name: "ThS. Phạm Minh Tuấn",
      position: "Giảng viên Thuật toán",
      specialization: "Cấu trúc dữ liệu & Thuật toán",
      experience: "12 năm kinh nghiệm",
      achievements: "Cựu Software Engineer Google, chuyên gia ACM-ICPC",
      image:
        "https://readdy.ai/api/search-image?query=Young%20Vietnamese%20male%20programming%20instructor%2C%20casual%20professional%20attire%20with%20friendly%20demeanor%2C%20modern%20tech%20workspace%20with%20multiple%20monitors%20and%20coding%20environment%2C%20professional%20headshot%20with%20clean%20white%20background&width=400&height=400&seq=teacher-cs-2&orientation=squarish",
    },
    {
      name: "TS. Hoàng Thị Mai",
      position: "Giảng viên Đại số",
      specialization: "Lý thuyết số & Đại số",
      experience: "18 năm kinh nghiệm",
      achievements: "Tiến sĩ Toán học ĐH Oxford, chuyên gia IMO",
      image:
        "https://readdy.ai/api/search-image?query=Professional%20Vietnamese%20female%20mathematics%20professor%2C%20elegant%20woman%20with%20academic%20appearance%20and%20warm%20smile%2C%20mathematics%20classroom%20with%20equations%20on%20whiteboard%2C%20professional%20portrait%20with%20clean%20white%20background&width=400&height=400&seq=teacher-math-3&orientation=squarish",
    },
    {
      name: "ThS. Đỗ Văn Hùng",
      position: "Giảng viên Machine Learning",
      specialization: "AI & Deep Learning",
      experience: "10 năm kinh nghiệm",
      achievements:
        "Cựu Research Scientist Facebook AI, PhD candidate Stanford",
      image:
        "https://readdy.ai/api/search-image?query=Modern%20Vietnamese%20AI%20researcher%20and%20teacher%2C%20young%20professional%20with%20contemporary%20style%20and%20intelligent%20expression%2C%20high-tech%20laboratory%20with%20AI%20equipment%20and%20neural%20network%20displays%2C%20professional%20headshot%20with%20clean%20white%20background&width=400&height=400&seq=teacher-ai-1&orientation=squarish",
    },
  ];

  // nut button
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="teachers" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Đội ngũ giảng viên
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Những chuyên gia hàng đầu trong lĩnh vực Toán học và Lập trình,
              với kinh nghiệm giảng dạy phong phú và thành tích xuất sắc
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teachers.map((teacher, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden"
              >
                <div className="relative">
                  <img
                    src={teacher.image}
                    alt={teacher.name}
                    className="w-full h-64 object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {teacher.name}
                  </h3>

                  <p className="text-blue-600 font-semibold mb-1">
                    {teacher.position}
                  </p>

                  <p className="text-gray-600 text-sm mb-3">
                    {teacher.specialization}
                  </p>

                  <div className="flex items-center space-x-2 mb-4">
                    <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center">
                      <i className="ri-time-line text-green-600 text-xs"></i>
                    </div>
                    <span className="text-sm text-gray-600">
                      {teacher.experience}
                    </span>
                  </div>

                  <p className="text-gray-700 text-sm leading-relaxed">
                    {teacher.achievements}
                  </p>

                  <div className="mt-4 pt-4 border-t border-gray-200">
                    <button
                      onClick={() => scrollToSection("contact")}
                      className="text-blue-600 hover:text-blue-700 font-semibold text-sm cursor-pointer whitespace-nowrap"
                    >
                      Đăng ký học thử →
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-16">
            <div className="bg-white rounded-2xl shadow-lg p-8 max-w-4xl mx-auto">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Tại sao chọn đội ngũ giảng viên của chúng tôi?
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-award-line text-blue-600 text-2xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">
                    Trình độ cao
                  </h4>
                  <p className="text-gray-600 text-sm">
                    100% giảng viên có bằng Thạc sĩ trở lên từ các trường đại
                    học danh tiếng
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-lightbulb-line text-purple-600 text-2xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">
                    Phương pháp hiện đại
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Áp dụng các phương pháp giảng dạy tiên tiến và công nghệ
                    giáo dục mới nhất
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-heart-line text-green-600 text-2xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">
                    Tận tâm với học sinh
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Luôn đồng hành và hỗ trợ học sinh phát triển tối đa tiềm
                    năng
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
